(function() {
    'use strict';

    angular.module('app.ui')
        .controller('DiskCtrl', DiskCtrl)
    ;

    /* @ngInject */
    function DiskCtrl() {
        var vm = this;

        vm.fontSize = (vm.size * .25) + 'px';
    }

})();